
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { IRect, IAnnotation } from '@/types';
import { Prop, Watch } from 'vue-property-decorator';
import Transcription from '../../store/modules/transcription';
import store from '@/store/store';
import axios from 'axios';

const trscModule = getModule(Transcription, store);
@Component
export default class AnnotationDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  @Prop(Object)
  data!: IAnnotation;

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit('input', value);
  }

  get isCurrentUserEditing() {
    return trscModule.isCurrentUserEditing;
  }

  async save() {
    this.show = false;
    return await trscModule.saveAnnotation({ anno: this.data });
  }

  async remove() {
    this.show = false;
    console.log(this.data);
    return await trscModule.removeAnnotation({ id: this.data.id });
  }

  cancel() {
    this.show = false;
  }
}
